/**
 * AceCollect MCP server の版 (steering 614)。
 *
 * 配布 artifact (`frontend/public/mcp/acecollect-mcp.mjs`) の banner と、MCP `initialize` の
 * `serverInfo.version`、職員 API へ送る User-Agent に使う。**tool の契約を変えたら上げる。**
 */
export const MCP_SERVER_NAME = 'acecollect';
export const MCP_SERVER_VERSION = '0.13.15';
export const MCP_USER_AGENT = `acecollect-mcp/${MCP_SERVER_VERSION}`;
